import React, { useContext } from 'react';
import { IndexContext } from '../../context'

const Video = ({ howItWorksVideo, handleVideoPopup }) => {
  const { baseUrl } = useContext(IndexContext);

  const {
    workVidAlt = 'Holdshort Watch demo presentation',
    workDemoVid,
    workIco = '/public/images/shapes.svg?v=3.1.481-t.689#play-triangle',
    demoVideoT =  'Watch demo presentation',
    demoVideoS = 'Holdshort App for Aircraft Scheduling'
  } = howItWorksVideo

  return (
    <div className="index-demo-video">
      <picture>
        <source srcSet={workDemoVid} type="image/jpg" />
        <img
          className="index-demo-video-img lazyload"
          data-src={baseUrl + workDemoVid}
          alt={workVidAlt}
        />
      </picture>
      <button
        type="botton"
        className="index-demo-video-btn"
        aria-label="Watch demo presentation"
        onClick={() => handleVideoPopup(true)}
      >
        <svg width="56px" height="68px" className="svg-sprite">
          <use href={baseUrl + workIco}/>
        </svg>
      </button>
      <p className="index-demo-video-text" children={demoVideoT}/>
      <small className="index-demo-video-small" children={demoVideoS}/>
    </div>
  );
};

export default Video;
